/**
 * Delete Card Confirmation Modal
 *
 * Modal dialog to confirm deletion of a saved card.
 */

import type { SavedCard } from '@/types/voice-dtmf.types';
import styles from './DeleteCardModal.module.css';

interface DeleteCardModalProps {
  card: SavedCard;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteCardModal = ({
  card: _card,
  onConfirm,
  onCancel,
}: DeleteCardModalProps) => {
  return (
    <div className={styles.overlay} onClick={onCancel}>
      <div
        className={styles.modal}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="delete-modal-title"
        aria-describedby="delete-modal-description"
      >
        <h3 id="delete-modal-title" className={styles.title}>
          Delete card?
        </h3>

        <p id="delete-modal-description" className={styles.message}>
          Once deleted, the customer will no longer be able to select this card
          from their saved payment methods.
        </p>

        <div className={styles.actions}>
          <button
            type="button"
            className={styles.deleteButton}
            onClick={onConfirm}
          >
            Delete Card
          </button>
          <button
            type="button"
            className={styles.cancelButton}
            onClick={onCancel}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};
